export const TIME_UNIT = 'time_unit'
export const TIME_UNIT_COUNT = 'time_unit_count'
export const MAX_IMPRESSIONS = 'max_impressions'

export const timeUnits = {
  DAY: 'DAY',
  HOUR: 'HOUR',
  MINUTE: 'MINUTE',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  LIFETIME: 'LIFETIME'
}

export const timeUnitOptions = [
  { value: timeUnits.DAY, label: 'Day' },
  { value: timeUnits.HOUR, label: 'Hour' },
  { value: timeUnits.MINUTE, label: 'Minute' },
  { value: timeUnits.WEEK, label: 'Week' },
  { value: timeUnits.MONTH, label: 'Month' },
  { value: timeUnits.LIFETIME, label: 'Lifetime' }
]
